import { render, staticRenderFns } from "./TransferGoodsadd.vue?vue&type=template&id=3f03eff2&scoped=true&"
import script from "./TransferGoodsadd.vue?vue&type=script&lang=js&"
export * from "./TransferGoodsadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f03eff2",
  null
  
)

export default component.exports